import { useSyncExternalStore } from "react";

/** Breakpoint md (744 px, Designsprache-Tokens 3.2): Seitenleiste statt Tab-Leiste, Dialog statt Sheet. */
const ABFRAGE = "(min-width: 744px)";

function abonnieren(melden: () => void) {
  const m = window.matchMedia(ABFRAGE);
  m.addEventListener("change", melden);
  return () => m.removeEventListener("change", melden);
}

export function useBreit(): boolean {
  return useSyncExternalStore(
    abonnieren,
    () => window.matchMedia(ABFRAGE).matches,
    () => false,
  );
}

const WEIT = "(min-width: 1024px)";

/** Breakpoint lg (1024 px): Zweispalter mit rechter Spalte (Posteingang, Dokument mit Panel; Plan 6.5). */
export function useWeit(): boolean {
  return useSyncExternalStore(
    (melden) => {
      const m = window.matchMedia(WEIT);
      m.addEventListener("change", melden);
      return () => m.removeEventListener("change", melden);
    },
    () => window.matchMedia(WEIT).matches,
    () => false,
  );
}
